module.exports = __webpack_public_path__ + "static/media/bk-offers-inactive.bd41fc52.png";